"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const simpleId_1 = require("../utilites/simpleId");
const cast_1 = require("../utilites/cast");
const Contributor_1 = require("./Contributor");
const AWConfiguration_1 = require("./AWConfig/AWConfiguration");
class Artwork {
    constructor() {
        this.id = '';
        this.title = '';
        this.published = false;
        this.credits = [];
        this.year = 0;
        this.description = '';
        this.configurations = [];
        this.controls = [];
        this.stats = null;
    }
    static preset() {
        const w = new Artwork();
        w.configurations = [new AWConfiguration_1.AWConfiguration(simpleId_1.simpleId())];
        return w;
    }
    static from(object) {
        return cast_1.castToType(object, Artwork);
    }
}
exports.Artwork = Artwork;
Artwork.propFactory = {
    credits: (object) => cast_1.castToArrayOfType(object, Contributor_1.Contributor),
    configurations: (object) => cast_1.castToArrayOfType(object, AWConfiguration_1.AWConfiguration)
};
